import { render, staticRenderFns } from "./Tab-List.vue?vue&type=template&id=5dcc1b88"
import script from "./Tab-List.vue?vue&type=script&lang=js"
export * from "./Tab-List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports